import { ReportCloudButtonsComponent } from '../../../reports/report-cloud-buttons/report-cloud-buttons.component';
import { NgModule } from '@angular/core';
import { GodReportsComponent } from './god-reports.component';
import { Gt2PrimengModule } from '../../../modules/gt2-primeng.module';
import { RouterModule } from '@angular/router';
import { AppRoutesName } from '../../../const/AppRoutesName';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../../@fuse/pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { ReportButtonComponent } from '../../../reports/report-button/report-button.component';

const routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.GOD_REPORTS,
    component: GodReportsComponent,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.GOD_REPORTS,
    component: GodReportsComponent,
  },
];

@NgModule({
  declarations: [GodReportsComponent],
  imports: [
    ReportCloudButtonsComponent,
    CommonModule,
    FormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    ReactiveFormsModule,
    TranslateModule,
    Gt2PrimengModule,
    RouterModule.forChild(routes),
    ReportButtonComponent,
  ],
  exports: [GodReportsComponent],
})
export class GodReportsModule {}
